<template>
  <div id="choujiang">
    <div class="rule-gift">
      <div @click="showGiftModal = true" class="gift">
        <van-icon name="gift"></van-icon>奖品
      </div>
      <div @click="showRuleModal = true" class="rule">
        <van-icon name="comment-o"></van-icon>规则
      </div>
    </div>
    <div>
      <div class="wrapper" @click.stop>
        <LuckyWheel
          ref="myLucky"
          width="300px"
          height="300px"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          @start="startCallback"
          @end="endCallback"
        />
      </div>
    </div>

    <van-overlay
      :show="showWinnerForm"
      class="winner-form-overlay quick-add-overlay"
      :z-index="999"
    >
      <div class="form-zone" @click.stop>
        <div class="quick-title">{{ afterReturnRand.msg }}</div>
        <div class="quick-sm">个人信息我们将严格保密，仅作兑奖凭证。</div>
        <van-form @submit="doSignWinner">
          <van-field
            v-model="winner.name"
            label="姓名"
            type="input"
            placeholder="请输入姓名"
            required
            error
          />

          <van-field
            v-model="winner.id_card"
            label="身份证号"
            type="input"
            placeholder="请输入身份证号"
            required
            error
          />

          <div style="margin: 16px">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              :disabled="!winner.name || !winner.id_card"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </van-overlay>

    <van-popup v-model="showGiftModal" class="gift-modal">
      <div class="title">我的奖品</div>
      <div class="prize">
        <span>{{ myPrize }}</span>
      </div>
    </van-popup>

    <van-popup v-model="showRuleModal" class="gift-modal">
      <div class="title">活动规则</div>
      <div class="prize">
        总积分达到150分可参与抽奖，每次消耗50积分。（消耗游戏积分，不消耗真实积分）
      </div>

      <div class="title">抽奖时间</div>
      <div class="prize">7月1日10点</div>

      <div class="title">奖品设置</div>
      <div class="prize">
        <div>一等奖：价值2899元的钱江电动车</div>
        <div>二等奖：价值1590元“温岭在海边民宿”入住体验一晚</div>
        <div>三等奖：价值268元的野海子露营基地单人露营体验</div>
        <div>四等奖：价值150元农产品大礼包</div>
        <div>参与奖：5斤葡萄</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import Vue from "vue";
import {
  loadPrize,
  getPrizeRand,
  savePrizeWinner,
  getMyPrize,
} from "@/api/tmnc";
import VueLuckyCanvas from "@lucky-canvas/vue";
import { Dialog, Toast } from "vant";

Vue.use(VueLuckyCanvas);

export default {
  name: "TmncChoujiang",
  data() {
    return {
      msg: "终极抽奖将于7月1日10点正式开启，敬请期待。",
      origin: "tmnc2022",
      showLottery: false,
      blocks: [{ padding: "13px", background: "#FDE52D" }],
      prizes: [],
      buttons: [
        { radius: "50px", background: "#F87F02" },
        { radius: "45px", background: "#ffffff" },
        {
          radius: "40px",
          background: "#D43128",
          pointer: true,
          fonts: [{ text: "开始\n抽奖", top: "-20px" }],
        },
      ],
      lotterying: false,
      // prizeRecord: {},
      afterReturnRand: {},
      showWinnerForm: false,
      winner: { name: "", id_card: "" },
      showGiftModal: false,
      myPrize: "很遗憾，您还没有奖品。",
      submiting: false,
      showRuleModal: false,
    };
  },
  mounted() {
    const startTime = dayjs("2022-07-01 10:00:00");
    const nowTime = dayjs();

    const diff = startTime.diff(nowTime);
    if (diff <= 0) {
      this.showLottery = true;
    }

    this.onLoadPrize();

    this.onGetMyPrize();
  },
  methods: {
    onGetMyPrize() {
      getMyPrize({ origin: this.origin }).then((res) => {
        // console.log("myp", res);
        if (res.code == 1) {
          let data = res.data;
          if (data) {
            this.myPrize = data.title;
          } else {
            this.myPrize = res.msg;
          }
        }
      });
    },
    onLoadPrize() {
      loadPrize({ origin: this.origin }).then((res) => {
        if (res.code == 1) {
          // console.log(res.data);
          if (res.code == 1) {
            let results = res.data.rows;
            results.forEach((v, k) => {
              let prize = {
                fonts: [
                  { text: v.title, top: "10%", fontSize: 16, lengthLimit: 80 },
                ],
              };
              if (k % 2 == 0) {
                prize.background = "#FFF4D6";
              } else {
                prize.background = "#FFFFFF";
              }
              this.prizes.push(prize);
            });
          }
        }
      });
    },
    doSignWinner() {
      if (this.submiting) return false;
      // this.submiting = true;

      let data = this.winner;
      this.$set(data, "origin", this.origin);

      savePrizeWinner(data).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          Toast.success(res.msg);
          this.showWinnerForm = false;
        } else {
          Toast.fail(res.msg);
        }

        this.submiting = false;
      });
    },
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if (this.showLottery == false) {
        Dialog({ message: this.msg });
        return false;
      }
      if (this.lotterying) return false;
      this.lotterying = true;

      getPrizeRand({
        origin: this.origin,
      }).then((res) => {
        // console.log(res)
        if (res.code == 1) {
          // 调用抽奖组件的play方法开始游戏
          this.$refs.myLucky.play();
          let result = res.data;

          const index = result.index;
          // 调用stop停止旋转并传递中奖索引
          this.$refs.myLucky.stop(index);

          this.afterReturnRand = res;
        } else {
          Toast.fail(res.msg);
        }
        this.lotterying = false;
      });
    },
    // 抽奖结束会触发end回调
    endCallback(prize) {
      // console.log('end', prize)
      // this.prizeRecord.status = "1";
      let result = this.afterReturnRand.data;
      if (result.is_win) {
        // 中奖了，信息登记
        Toast.success(this.afterReturnRand.msg);
        // this.showLottery = false;
        this.myPrize = result.title;
        this.$nextTick(() => {
          this.showWinnerForm = true;
        });
      } else {
        // this.showLottery = false;
        Toast({ message: this.afterReturnRand.msg, duration: 4000 });
      }
    },
  },
};
</script>

<style lang="less" scoped>
#choujiang {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(https://i.tmuyun.com/webpic/W0202205/W020220530/W020220530566869774115.jpg);
  background-size: 100%;
  background-color: #a17651;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  .model {
    position: relative;
    width: 60vw;
    img {
      width: 100%;
    }
  }

  .rule-gift {
    position: absolute;
    right: 5px;
    top: 10px;
    color: #fff;
    .rule {
      margin-top: 10px;
    }
  }

  .gift-modal {
    border-radius: 15px;
    min-width: 70vw;
    padding: 10px;
    .title {
      text-align: center;
      color: #ff6f22;
      font-size: 1.2rem;
      font-weight: bold;
      margin-top: 10px;
    }
    .prize {
      margin-top: 10px;
    }
  }
  .quick-add-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .form-zone {
      width: 85vw;
      background-color: #fff;
      padding: 10px 0;
      border-radius: 10px;
      .quick-title {
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }
      .quick-sm {
        text-align: center;
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>